import { normalizeTrailingSlash } from "@/constants/locale";
import { useGlobalStore } from "@/stores/global";

export default defineNuxtRouteMiddleware(async (to) => {
  // Set the status code to 404 for a custom 404 page
  const store = useGlobalStore();
  let splitPath = to.path.split("/")?.map((data) => `/${data}`);
  //set cookie for 2 months
  const preferedCountry = useCookie("preferredCountry", {
    maxAge: 30 * 86400 * 2,
    watch: true,
  });

  const localeRoute = useLocaleRoute();

  if (to.path == "/" && !preferedCountry.value) {
    if (import.meta.server) {
      const ipLookupData = await store.getIpLookUp();
      if (ipLookupData) {
        preferedCountry.value = ipLookupData;
      }
      const routeUrl = localeRoute(to.path, ipLookupData);
      const fullPath = routeUrl?.fullPath;
      // Carry the query (gclid, utm_*, ...) through so ad clicks on "/" keep it
      if (fullPath) return navigateTo({ path: fullPath + "/", query: to.query, hash: to.hash }, { redirectCode: 301 });
      return navigateTo(
        { path: `/${store.siteDefaultLocale ?? "en-au"}/`, query: to.query, hash: to.hash },
        { redirectCode: 301 }
      );
    }
  } else if (to.path == "/" && preferedCountry.value) {
    const routeUrl = localeRoute(to.path, preferedCountry.value);
    const fullPath = routeUrl?.fullPath;
    if (fullPath) return navigateTo({ path: fullPath + "/", query: to.query, hash: to.hash }, { redirectCode: 301 });
    return navigateTo(
      { path: `/${store.siteDefaultLocale ?? "en-au"}/`, query: to.query, hash: to.hash },
      { redirectCode: 301 }
    );
  }

  // Never build a redirect from a protocol-relative path ("//host", "/\host");
  // navigateTo would refuse it anyway, but a 500 is a worse failure than a no-op
  if (to.path.startsWith("//") || to.path.startsWith("/\\")) return;

  // /en and /es only serve the blog — send their roots there in one hop
  const blogOnlyRoot = ["/en", "/es"].find((p) => to.path === p || to.path === `${p}/`);
  if (blogOnlyRoot) {
    return navigateTo({ path: `${blogOnlyRoot}/blog`, query: to.query, hash: to.hash }, { redirectCode: 301 });
  }

  // Enforce the trailing-slash policy: locale homepages end in a slash
  // (/en-au -> /en-au/), every other path does not. Stripping on full page
  // loads is handled by server/middleware/00.trailing-slash.ts; this covers
  // adding the homepage slash and client-side navigations.
  const normalizedPath = normalizeTrailingSlash(to.path);
  if (normalizedPath !== to.path) {
    return navigateTo({ path: normalizedPath, query: to.query, hash: to.hash }, { redirectCode: 301 });
  }

  // Set the status code to 404 for a custom 404 page
  if (splitPath.some((word) => ["/en", "/es"].includes(word)) && !to.path.includes("/blog")) {
    throw createError({ statusCode: 404, statusMessage: "Page Not Found" });
  }
});
